import React, { useContext, useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./styles.scss";
import { Sidebar, Footer, ScrollToTop } from "./components";
import { AuthContext } from "./contexts/AuthContext";
import { useStateContext } from "./contexts/ContextProvider";
import { messaging } from "./firebase";
import { onMessage } from "firebase/messaging";
import {
  Login,
  ProfilUser,
  UbahProfilUser,
  DaftarUser,
  TambahUser,
  UbahUser,
  TampilSetting,
  UbahSetting,
  TampilPeserta,
  UbahPeserta,
  TambahPeserta,
  TampilCabang,
  UbahCabang,
  TambahCabang,
  TampilDaftarKelompok,
  TambahKelompok,
  TampilKelompok,
  UbahKelompok,
  TambahPesertaKelompok,
  TampilPesertaKelompok,
  UbahPesertaKelompok,
  TampilAngsuranKelompok,
  UbahAngsuranKelompok,
  TampilMisalLelangKelompok,
  UbahMisalLelangKelompok,
  TampilHitunganSimulasi,
  UbahHitunganSimulasi,
  TampilSetoranAngsuranKelompok,
  TambahSetoranAngsuranKelompok,
  TampilBiayaAngsuranKelompok,
  UbahBiayaAngsuranKelompok,
  TambahBiayaAngsuranKelompok,
  TampilLelangBulanan,
  UbahLelangBulanan,
  TambahLelangBulanan,
  TampilBid,
  UbahBid,
  TambahBid,
  TampilPenetapanPemenang,
  UbahPenetapanPemenang,
  TambahPenetapanPemenang,
  LaporanPenerimaan,
  LaporanBiaya,
  LaporanPemenang,
  LaporanKeuangan,
  LaporanTunggakan,
} from "./pages/index";
import { FaBars } from "react-icons/fa";
import toast, { Toaster } from "react-hot-toast";

const App = () => {
  const { screenSize, setScreenSize } = useStateContext();
  const { user } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  const notify = (body) => {
    toast.custom(
      (t) => (
        <div
          style={{
            background: "#333",
            color: "white",
            padding: "12px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            minWidth: "260px",
          }}
        >
          <span style={{ whiteSpace: "pre-line" }}>{body}</span>
          <button
            onClick={() => toast.dismiss(t.id)}
            style={{
              background: "transparent",
              border: "none",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>
      ),
      {
        duration: Infinity, // 👈 stick forever
        position: "top-right",
      },
    );
  };

  const USERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user) {
      return children;
    }

    return <Navigate to="/login" />;
  };

  const PROFILUSERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.profilUser) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const DAFTARUSERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.daftarUser) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const SETTINGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.setting) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PESERTARoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.peserta) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const CABANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.cabang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const KELOMPOKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.kelompok) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const SETORANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.setoran) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const BIAYARoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.biaya) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LELANGBULANANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.lelangBulanan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const BIDRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.bid) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PENETAPANPEMENANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.penetapanPemenang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANPENERIMAANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanPenerimaan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANBIAYARoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanBiaya) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANPEMENANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanPemenang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANKEUANGANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanKeuangan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANTUNGGAKANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanTunggakan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  useEffect(() => {
    onMessage(messaging, (payload) => {
      // console.log(payload);
      notify(payload.notification.body);
    });

    // const handleResize = () => setScreenSize(window.innerWidth);
    // window.addEventListener("resize", handleResize);
    // handleResize();
    // return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Toaster />
      <div className={`app ${toggled ? "toggled" : ""}`}>
        {user && (
          <Sidebar
            collapsed={collapsed}
            toggled={toggled}
            handleToggleSidebar={handleToggleSidebar}
            handleCollapsedChange={handleCollapsedChange}
          />
        )}

        <main>
          <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
            <FaBars />
          </div>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            {/* Profil User */}
            <Route
              path="/profilUser"
              element={
                <PROFILUSERRoute>
                  <ProfilUser />
                </PROFILUSERRoute>
              }
            />
            <Route
              path="/profilUser/:id/edit"
              element={
                <PROFILUSERRoute>
                  <UbahProfilUser />
                </PROFILUSERRoute>
              }
            />
            {/* Daftar User */}
            <Route
              path="/daftarUser"
              element={
                <DAFTARUSERRoute>
                  <DaftarUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/daftarUser/:id"
              element={
                <DAFTARUSERRoute>
                  <DaftarUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/daftarUser/:id/edit"
              element={
                <DAFTARUSERRoute>
                  <UbahUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/daftarUser/tambahUser"
              element={
                <DAFTARUSERRoute>
                  <TambahUser />
                </DAFTARUSERRoute>
              }
            />
            {/* Setting */}
            <Route
              path="/setting"
              element={
                <SETTINGRoute>
                  <TampilSetting />
                </SETTINGRoute>
              }
            />
            <Route
              path="/setting/:id/edit"
              element={
                <SETTINGRoute>
                  <UbahSetting />
                </SETTINGRoute>
              }
            />
            {/* Peserta */}
            <Route
              path="/peserta"
              element={
                <PESERTARoute>
                  <TampilPeserta />
                </PESERTARoute>
              }
            />
            <Route
              path="/peserta/:id"
              element={
                <PESERTARoute>
                  <TampilPeserta />
                </PESERTARoute>
              }
            />
            <Route
              path="/peserta/:id/edit"
              element={
                <PESERTARoute>
                  <UbahPeserta />
                </PESERTARoute>
              }
            />
            <Route
              path="/peserta/tambahPeserta"
              element={
                <PESERTARoute>
                  <TambahPeserta />
                </PESERTARoute>
              }
            />
            {/* Cabang */}
            <Route
              path="/cabang"
              element={
                <CABANGRoute>
                  <TampilCabang />
                </CABANGRoute>
              }
            />
            <Route
              path="/cabang/:id"
              element={
                <CABANGRoute>
                  <TampilCabang />
                </CABANGRoute>
              }
            />
            <Route
              path="/cabang/:id/edit"
              element={
                <CABANGRoute>
                  <UbahCabang />
                </CABANGRoute>
              }
            />
            <Route
              path="/cabang/tambahCabang"
              element={
                <CABANGRoute>
                  <TambahCabang />
                </CABANGRoute>
              }
            />
            {/* ARISAN */}
            {/* Kelompok */}
            <Route
              path="/daftarKelompok"
              element={
                <KELOMPOKRoute>
                  <TampilDaftarKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/tambahKelompok"
              element={
                <KELOMPOKRoute>
                  <TambahKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id"
              element={
                <KELOMPOKRoute>
                  <TampilKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/edit"
              element={
                <KELOMPOKRoute>
                  <UbahKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/tambahPesertaKelompok"
              element={
                <KELOMPOKRoute>
                  <TambahPesertaKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/:idPesertaKelompok"
              element={
                <KELOMPOKRoute>
                  <TampilPesertaKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/:idPesertaKelompok/edit"
              element={
                <KELOMPOKRoute>
                  <UbahPesertaKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/angsuran/:idAngsuranKelompok"
              element={
                <KELOMPOKRoute>
                  <TampilAngsuranKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/angsuran/:idAngsuranKelompok/edit"
              element={
                <KELOMPOKRoute>
                  <UbahAngsuranKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/misalLelangKelompok/:idMisalLelangKelompok"
              element={
                <KELOMPOKRoute>
                  <TampilMisalLelangKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/misalLelangKelompok/:idMisalLelangKelompok/edit"
              element={
                <KELOMPOKRoute>
                  <UbahMisalLelangKelompok />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/hitunganSimulasi/:idHitunganSimulasi"
              element={
                <KELOMPOKRoute>
                  <TampilHitunganSimulasi />
                </KELOMPOKRoute>
              }
            />
            <Route
              path="/daftarKelompok/kelompok/:id/hitunganSimulasi/:idHitunganSimulasi/edit"
              element={
                <KELOMPOKRoute>
                  <UbahHitunganSimulasi />
                </KELOMPOKRoute>
              }
            />
            {/* Setoran */}
            <Route
              path="/setoran"
              element={
                <SETORANRoute>
                  <TampilSetoranAngsuranKelompok />
                </SETORANRoute>
              }
            />
            <Route
              path="/setoran/tambahSetoran"
              element={
                <SETORANRoute>
                  <TambahSetoranAngsuranKelompok />
                </SETORANRoute>
              }
            />
            <Route
              path="/setoran/:id"
              element={
                <SETORANRoute>
                  <TampilSetoranAngsuranKelompok />
                </SETORANRoute>
              }
            />
            {/* Biaya */}
            <Route
              path="/biaya"
              element={
                <BIAYARoute>
                  <TampilBiayaAngsuranKelompok />
                </BIAYARoute>
              }
            />
            <Route
              path="/biaya/:id"
              element={
                <BIAYARoute>
                  <TampilBiayaAngsuranKelompok />
                </BIAYARoute>
              }
            />
            <Route
              path="/biaya/:id/edit"
              element={
                <BIAYARoute>
                  <UbahBiayaAngsuranKelompok />
                </BIAYARoute>
              }
            />
            <Route
              path="/biaya/tambahBiaya"
              element={
                <BIAYARoute>
                  <TambahBiayaAngsuranKelompok />
                </BIAYARoute>
              }
            />
            {/* Lelang Bulanan */}
            <Route
              path="/lelangBulanan"
              element={
                <LELANGBULANANRoute>
                  <TampilLelangBulanan />
                </LELANGBULANANRoute>
              }
            />
            <Route
              path="/lelangBulanan/:id"
              element={
                <LELANGBULANANRoute>
                  <TampilLelangBulanan />
                </LELANGBULANANRoute>
              }
            />
            <Route
              path="/lelangBulanan/:id/edit"
              element={
                <LELANGBULANANRoute>
                  <UbahLelangBulanan />
                </LELANGBULANANRoute>
              }
            />
            <Route
              path="/lelangBulanan/tambahLelangBulanan"
              element={
                <LELANGBULANANRoute>
                  <TambahLelangBulanan />
                </LELANGBULANANRoute>
              }
            />
            {/* Bid */}
            <Route
              path="/bid"
              element={
                <BIDRoute>
                  <TampilBid />
                </BIDRoute>
              }
            />
            <Route
              path="/bid/:id"
              element={
                <BIDRoute>
                  <TampilBid />
                </BIDRoute>
              }
            />
            <Route
              path="/bid/:id/edit"
              element={
                <BIDRoute>
                  <UbahBid />
                </BIDRoute>
              }
            />
            <Route
              path="/bid/tambahBid"
              element={
                <BIDRoute>
                  <TambahBid />
                </BIDRoute>
              }
            />
            {/* Penetapan Pemenang */}
            <Route
              path="/penetapanPemenang"
              element={
                <PENETAPANPEMENANGRoute>
                  <TampilPenetapanPemenang />
                </PENETAPANPEMENANGRoute>
              }
            />
            <Route
              path="/penetapanPemenang/:id"
              element={
                <PENETAPANPEMENANGRoute>
                  <TampilPenetapanPemenang />
                </PENETAPANPEMENANGRoute>
              }
            />
            <Route
              path="/penetapanPemenang/:id/edit"
              element={
                <PENETAPANPEMENANGRoute>
                  <UbahPenetapanPemenang />
                </PENETAPANPEMENANGRoute>
              }
            />
            <Route
              path="/penetapanPemenang/tambahPenetapanPemenang"
              element={
                <PENETAPANPEMENANGRoute>
                  <TambahPenetapanPemenang />
                </PENETAPANPEMENANGRoute>
              }
            />
            {/* LAPORAN */}
            <Route
              path="/laporanPenerimaan"
              element={
                <LAPORANPENERIMAANRoute>
                  <LaporanPenerimaan />
                </LAPORANPENERIMAANRoute>
              }
            />
            <Route
              path="/laporanBiaya"
              element={
                <LAPORANBIAYARoute>
                  <LaporanBiaya />
                </LAPORANBIAYARoute>
              }
            />
            <Route
              path="/laporanPemenang"
              element={
                <LAPORANPEMENANGRoute>
                  <LaporanPemenang />
                </LAPORANPEMENANGRoute>
              }
            />
            <Route
              path="/laporanKeuangan"
              element={
                <LAPORANKEUANGANRoute>
                  <LaporanKeuangan />
                </LAPORANKEUANGANRoute>
              }
            />
            <Route
              path="/laporanTunggakan"
              element={
                <LAPORANTUNGGAKANRoute>
                  <LaporanTunggakan />
                </LAPORANTUNGGAKANRoute>
              }
            />
          </Routes>
          <Footer />
        </main>
      </div>
    </>
  );
};

export default App;
